<div class="property-card cursor mobile-overlay-card" (click)="redirectProperty()">
    
    <div class="card-image-wrapper image-layer">
        <div class="card-image">
            <img [src]="propertyImage ? shared.getImageURL(propertyImage) : '/assets/images/no-image.jpg'" 
                alt="{{propertyData.property_name}}" class="property-image">
            
            <div class="image-overlay-tags">
                <div class="property-tag" 
                    [ngClass]="propertyData.selling_type == 2 ? 'rent-tag-red' : 'sale-tag-green'">
                    {{ propertyData.selling_type == 2 ? 'For Rent' : 'For Sale' }}
                </div>
            </div>
        </div>
    </div>

    <div class="card-content d-flex flex-column mobile-content-overlay"> 
        
        <div class="header-row d-flex justify-content-between align-items-center">
            <h3 class="property-name">{{ propertyData.property_name }}</h3>
        </div>
        
        <p class="location-tagline">
            {{ propertyData.PropertyToMasterPropertyTypeData.property_type }} in {{ propertyData.tagline }}, {{ propertyData.PropertyToMasterCityData?.city_name || 'Ahmedabad' }}
        </p>

     <div class="unit-details-table-line mt-2 d-flex align-items-center mobile-stack-details">
    
    <div class="unit-item-equal mobile-detail-item">
        <p class="mb-0 unit-value"><strong>{{ propertyData.no_of_bedrooms || 3 }} BHK Flat</strong></p>
    </div>
    
    <div class="unit-item-equal text-left mobile-detail-item">
        <p class="mb-0 unit-value">{{ propertyData.plot_area || 677 }} Sq-yrd</p>
    </div>
    
    <div class="unit-item-equal mobile-detail-item">
        <p class="mb-0 unit-value">
            Launch price: 
            <strong>{{ shared.formatPriceAED(propertyData.price) || '1.6M AED' }}</strong>
            <i class="ion-ios-information-circle-outline price-info-icon mobile-hidden-icon"></i>
        </p>
    </div>

</div>
    
        <div class="footer-row d-flex justify-content-between align-items-center mt-auto">

            <div class="action-buttons-group">
              <button class="btn btn-icon-only call-icon" (click)="onPopup('call', propertyData.id, $event)">
    <i class="ion-ios-call"></i>
</button>

<button class="btn btn-icon-only mail-icon" (click)="onPopup('mail', propertyData.id, $event)">
    <i class="ion-ios-mail"></i>
</button>

<button class="btn btn-icon-only whatsapp-icon" (click)="onPopup('whatsapp', propertyData.id, $event)">
    <i class="ion-logo-whatsapp"></i>
</button>



                <button *ngIf="isMyProperty" class="btn btn-icon-only edit-icon" (click)="onEdit()"><i class="ion-ios-create"></i></button>
                <button *ngIf="isMyProperty" class="btn btn-icon-only delete-icon" (click)="onDelete()"><i class="ion-ios-trash"></i></button>
            </div>
        </div>
    </div>
</div>



<!-- <div *ngIf="is_delete_modal" class="modal-overlay"> -->
<div *ngIf="is_delete_modal" class="modal fade show OtherModalName modal-overlay-bg" data-bs-backdrop="static"
    data-bs-keyboard="false" tabindex="-1" style="display: block;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">
                    Confirmation
                </h5>
                <button type="button" class="btn-close" (click)="closeDeleteModal()"></button>
            </div>
            <div class="modal-body text">
                <p>Are you sure you want to delete selected property?</p>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn-primary" (click)="onSubmit()">Submit</button>
                <button type="button" class="btn-secodary" (click)="closeDeleteModal()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- </div> -->



<!-- Modal -->
<div class="modal fade" id="socialModal" tabindex="-1" *ngIf="currentPropertyId" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="socialModalLabel">
                    Contact details
                </h1>
                <button type="button" class="btn-close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
                <div class=""
                    *ngIf="subscriptionInfo && (subscriptionInfo.hasSubscription && !subscriptionInfo.result)">
                    <div class="">
                        <h5 class="card-text text-center alert alert-danger">
                            You have reached your limit. <br />You
                            cannot view more property. <br />If you want to view
                            more property, <br />please <a class="contact-link" href="contact"><span
                                    style="color: blue;">contact us</span></a>.
                        </h5>
                    </div>
                </div>

                <div class=" mt-3" *ngIf="subscriptionInfo && !subscriptionInfo.hasSubscription">
                    <div class="">
                        <h5 class="card-text text-center alert alert-danger">
                            You cannot view property. Please subscribe to view property.
                        </h5>
                        <div class="text-center">
                            <a [href]="getSubscriptionUrl()" class="btn btn-primary">Subscribe Now</a>
                        </div>
                    </div>
                </div>
                <!-- <form id="socialForm" [formGroup]="socialForm" name="socialForm" *ngIf="subscriptionInfo && (subscriptionInfo.hasSubscription && subscriptionInfo.result)"
            class="socialForm" method="POST"> -->
                <ng-container *ngIf="propertyDataInfo">
                    <div class="row mb-2">
                        <div class="col-5">
                            <label for="nameInput" class="form-label">Contact:</label>
                        </div>
                        <div class="col-7 pointer" (click)="onURL(propertyDataInfo,'phone')">
                            <p>{{propertyDataInfo.PropertyToUserData.phone}}</p>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-5">
                            <label for="nameInput" class="form-label">Email:</label>
                        </div>
                        <div class="col-7 pointer" (click)="onURL(propertyDataInfo,'email')">
                            <p>{{propertyDataInfo.PropertyToUserData.email}}</p>
                            <!-- <input type="email" class="form-control" formControlName="email"> -->
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-5">
                            <label for="nameInput" class="form-label">WhatsApp Number:</label>
                        </div>
                        <div class="col-7 pointer" (click)="onURL(propertyDataInfo,'wp')">
                            <p>{{propertyDataInfo.PropertyToUserData.whatsapp_no ?
                                propertyDataInfo.PropertyToUserData.whatsapp_no :
                                propertyDataInfo.PropertyToUserData.phone }}</p>
                            <!-- <input type="number" class="form-control" formControlName="whatsapp_number"> -->
                        </div>
                    </div>
                </ng-container>
                <!-- </form> -->

            </div>
            <!-- <div class="modal-footer" *ngIf="subscriptionInfo && (subscriptionInfo.hasSubscription && subscriptionInfo.result)">
          <button type="button" class="btn btn-primary" (click)="closeModal()">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="onSave()">Save</button>
        </div> -->
        </div>
    </div>
</div>